import React, { useState, useEffect } from 'react';
import { isEmpty, map } from 'lodash';
import { Carousel, Col, Row, Grid } from 'antd';
import './banner.scss';

export interface Slider {
  key?: string;
  imageUrl: string;
  href: string;
}

export interface SideBanner {
  key?: string;
  imageUrl: string;
  href: string;
}

export interface BannerProps {
  banners: {
    sliders: Slider[],
    sideBanners?: SideBanner[],
  }
}

export const Banner: React.FC<BannerProps> = ({ banners }) => {
  const { sliders, sideBanners } = banners;
  const [ mainColProps, setMainColProps ] = useState<any>({})
  const [ subColProps, setSubColProps ] = useState<any>({})
  const [ subRowProps, setSubRowProps ] = useState<any>([])
  const [ innerSubProps, setInnerSubProps ] = useState<any>({})

  const breakpoint = Grid.useBreakpoint();
  let sideBannersLength = sideBanners?.length || 0;

  useEffect(() => {
    if (sideBannersLength <= 2) {
      setMainColProps({ xxl: 16, xl: 16, lg: 16, md: 24, sm: 24, xs: 24 })
      setSubColProps({ xxl: 8, xl: 8, lg: 8, md: 24, sm: 24, xs: 24 })
      setInnerSubProps({ xxl: 24, xl: 24, lg: 24, md: 12, sm: 12, xs: 12 })
      setSubRowProps([])
    }
    else {
      setMainColProps({ xxl: 14, xl: 14, lg: 14, md: 24, sm: 24, xs: 24 })
      setSubColProps({ xxl: 9, xl: 9, lg: 9, md: 24, sm: 24, xs: 24 })
      setInnerSubProps({ xxl: 12, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 })
      setSubRowProps([5,5])
    }
  }, [sideBannersLength])

  return (
    <div className={sideBannersLength <= 2 ? "banner banner--2" : "banner banner--6"}>
      <Row gutter={16}>
        <Col {...mainColProps} className="sliders">
          <Carousel autoplay={true}>
            {map(sliders, (slider, index) => {
              return (
                <div
                  className="sliders--item" key={slider.key ? slider.key : index} style={{ margin: 'auto' }}>
                  <a>
                    <img src={slider.imageUrl} onClick={() => window.open(slider.href)} />
                  </a>
                </div>
              )
            })}
          </Carousel>
        </Col>

        {!isEmpty(sideBanners) &&
          !breakpoint.xs ?
          <Col
            {...subColProps}
            className={sideBannersLength <= 2 ? "sideBanners sideBanners--2" : "sideBanners sideBanners--6"}
          >
              <Row gutter={subRowProps}>

                {map(sideBanners, (banner, index) => {
                    return (
                      <Col
                        {...innerSubProps}
                        className={sideBannersLength <= 2 ? "sideBanners--item sideBanners--item-2" : "sideBanners--item sideBanners--item-6"}
                        key={banner.key ? banner.key : index}
                      >
                        <a>
                          <img src={banner.imageUrl} onClick={() => window.open(banner.href)} />
                        </a>
                      </Col>
                    )
                })}

              </Row>
            </Col>
            :
            <div className="scrollableSideBanners">
              {map(sideBanners, (banner, index) => {
                if (index = 1) {
                  return (
                    <img src={banner.imageUrl} onClick={() => window.open(banner.href)} />
                  )
                }
              })}
            </div>

        }

      </Row>
    </div>
  )
}
